import { useTranslation } from 'next-i18next'
import ModalSp from '../ui/ModalSp'

const SignatureModal = ({ src, isOpen, setOpen }) => {

  const { t } = useTranslation('tracking')

  return (
    <ModalSp
      open={isOpen}
      onClose={() => setOpen(false)}
      title={t('receiver-signature')}
    >
      <img src={src} alt="receivers signature" style={{ width: '100%' }} />
    </ModalSp>
  )
}

export default SignatureModal